// tslint:disable:max-classes-per-file
export class CoralClientConfigNotFound extends ReferenceError {
    constructor(service, { qualifier, key } = {}) {
        const keyClause = key ? `, key: "${key}"` : '';
        const qualifierClause = qualifier ? ` with qualifier "${qualifier}"` : '';
        const message = `[CoralClientConfigNotFound] No config found for ` +
            `${service}${qualifierClause}${keyClause}`;
        super(message);
        // as of TS2.1, extending built-ins like Error require a little extra
        // boilerplate to work properly. In TS2.2 this boilerplate was reduced, but
        // it's still necessary. For more, see:
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
/**
 * Catch-all exception for Coral operations when an unmodeled exception is received
 * or if a network failure occurs.
 *
 * Clients can access the <i>receivedException</i> property to inspect the
 * underlying error, and <i>status</i> to inspect the response status.
 */
export class UnknownCoralError extends Error {
    constructor(receivedException, status) {
        super('[UnknownCoralError] Encountered unknown coral exception');
        this.receivedException = receivedException;
        this.status = status;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
/**
 * Exception indicating that an `input` string expected to be JSON but was actually not.
 */
export class JsonParsingException extends Error {
    constructor(input, e) {
        super('[JsonParsingException] Could not parse the response as JSON: ' +
            `${input.substr(0, JsonParsingException.MAX_INPUT_LENGTH)}, original exception: ${e.message}`);
        this.input = input;
        this.e = e;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
JsonParsingException.MAX_INPUT_LENGTH = 1000; // prevent extra long errors from clogging the logs
